import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../apimethods/api-method';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../common/global-constants';
import { NotificationAPIModel } from './notification-model';
declare var $;

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
/** notification component*/
export class NotificationComponent {
  modelItem = new NotificationAPIModel();
  notificationCount: string;

  ngOnInit() {
    ApiMethod.getBaseUrl();
    $('#notificationList').css('height', (GlobalConstants.size.height - 100));
  }

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <NotificationAPIModel>data["NotificationAPIPage"];
        this.getNotificationList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
    });
      
  }

  getNotificationList() {
    var notificationdata = {
      RoleId: localStorage.roleId,
      LoginId: localStorage.aLoginID
    };

    ApiMethod.postMethod(this.modelItem.GetNotificationAPI, notificationdata).subscribe(
      result => {
        var notificationList = result.notificationList;
        this.notificationCount = result.unreadCount;
         if (this.notificationCount == "0") {
          $('#spCount').html('');
          $('#ibellAnimate').removeClass('bx-tada');
        }
        else {
          $('#spCount').html(result.unreadCount);
          //$('#ibellAnimate').addClass('bx-tada');
        }
        localStorage.notificationId = 0;

        var zTableList = '<div class="DivList"><table width="100%">';
        $.each(notificationList, function (e, val) {
          zTableList += '<tr style="background-color: #e6e9ff;border-bottom: #888888 2px solid;white-space: initial;" for="chk_' + val.Id + '">';
          zTableList += '<td>';
          zTableList += '<div class="row divDataItem" style="padding: 8px;">';
          zTableList += '<div class="col-sm-12 child"><strong>' + 'Title : ' + val.Title + '</strong></div>';
          zTableList += '<div class="col-sm-12 divPadd">' + 'Description : ' + val.Description + '</div>';
          zTableList += '<div class="col-sm-12 divPadd" title=' + GlobalConstants.FormatDate(val.CreatedTime) + '>' + 'TimeAgo : ' + val.TimeAgo + '</div>';
          if (val.isRead)
            zTableList += '<div class="col-sm-6 divPadd"><span><input type="checkbox" id="chk_' + val.Id + '" checked disabled="disabled" style="cursor: pointer"></span></div>';
          else
            zTableList += '<div class="col-sm-6 divPadd"><span><input type="checkbox" id="chk_' + val.Id + '" style="cursor: pointer" onclick=localStorage.notificationId="' + val.Id + '";$("#spReadNotification").trigger("click");></span></div>';

          zTableList += '</td></tr>';
        });

        zTableList += '</table></div>';
        
        if (notificationList.length == 0) {
          zTableList = '<h3 style="height: 100px; line-height: 100px; text-align: center;"> No data found !</h3>';
        }

        $('#notificationList').html(zTableList);

        $("#divNotification").html('');
        var TableList = "";
        $.each(notificationList, function (e, val) {
          TableList += "<a href='javascript: void(0);' class='text-reset notification-item'><div class='d-flex'>";
          TableList += "<div class='avatar-xs me-3'><span class='avatar-title bg-primary rounded-circle font-size-16'><i class='bx bx-task'></i></span></div>";
          TableList += "<div class='flex-grow-1'><h6 class='mb-1' key='t-your-order'>" + val.Title + "</h6><div class='font-size-12 text-muted'>";

          if (val.isRead)
            TableList += "<span style='float:right;'><input type='checkbox' checked disabled='disabled' style='cursor:pointer'></span>";
          else
            TableList += "<span style='float:right;'><input type='checkbox' style='cursor:pointer' onclick=localStorage.notificationId='" + val.Id + "';$('#spUpdateNotification').trigger('click');></span>";

          TableList += "<p class='mb-1' key='t-grammer' style='width:85%'>" + val.Description + "</p>";
          TableList += "<p class='mb-0'><i class='mdi mdi-clock-outline'></i> <span key='t-min-ago'>" + val.TimeAgo + "</span></p></div></div>";
          TableList += "</div></a>";
        });
        $("#divNotification").append(TableList);
      }, error => {
        ngswal("Failed !", error.message, "warning");
      });
  }

  readNotification() {
    var notificationdata = {
      Id: localStorage.notificationId,
      LoginId: localStorage.aLoginID,
      RoleId: localStorage.roleId
    };

    ApiMethod.postMethod(this.modelItem.ReadNotificationAPI, notificationdata).subscribe(
      result => {
        if (result.isRead) {
          ngswal("Succes !", "Notification read successfully !", "success");
          this.getNotificationList();
        } else {
          ngswal("Failed !", "Try after sometimes !", "warning");
        }
      }, error => {
        ngswal("Failed !", error.message, "warning");
      });
  }
}
